import Client from "./Client";
import {
  formatPackagesInList,
  formatSinglePackage
} from "../services/PackageFormatter";

export async function findPackagesByCustomer(codeOrCustomerId, isSpecials) {
  const httpClient = new Client();
  let url = `packages/by-customer/${codeOrCustomerId}`;
  if (isSpecials) {
    url += "/specials";
  }
  const response = await httpClient.get(url);
  return formatPackagesInList(response.data);
}

export async function findPackage(codeOrPackageId, isSpecial) {
  const httpClient = new Client();
  let url = `packages/${codeOrPackageId}`;
  if (isSpecial) {
    url += "/special";
  }
  const response = await httpClient.get(url);
  return formatSinglePackage(response.data);
}
